import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Site } from '@app-models/site';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { errorMessages as error } from '../../../../message/error';
import { SiteService } from '@app-services/site.service';
import { LoadingScreenService } from '@app-services/loading-screen.service';
import { checkInvalid } from 'src/app/validation';

@Component({
  selector: 'app-add-hospital',
  templateUrl: './add-hospital.component.html',
  styleUrls: ['./add-hospital.component.scss']
})
export class AddHospitalComponent implements OnInit {
  logoHospital: any;
  // private logoName: any;
  fileSizeError: boolean;
  fg: FormGroup;
  messageError = error;

  @ViewChild('form') formElementRef: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<AddHospitalComponent>,
    @Inject(MAT_DIALOG_DATA) public newSite: Site,
    private _fb: FormBuilder,
    private authSer: AuthService,
    private _ss: SiteService,
    private loadingScreenService: LoadingScreenService,
  ) {
    this.fileSizeError = false;
  }

  onFileChange(event) {
    this.logoHospital = event.target.files;
    // this.fg.displayNameLogo = event.target.files[0].name;
    console.log(event);
    if (this.logoHospital[0].size > 205000) {
      console.log('File is too big!');
      this.fg.get('displayLogoName').setValue('');
      this.fg.get('displayLogoName').setErrors({ 'size': true });
      this.fg.get('displayLogoName').markAsTouched();
    } else {
      this.fg.get('displayLogoName').setValue(this.logoHospital[0].name);
    }
  }

  // saveHospital() {
  //   this.authSer.uploadLogoToFireStorage(this.logoHospital);
  //   this.dialogRef.close();
  // }

  ngOnInit() {
    this.fg = this._fb.group({
      displayId: [this.newSite.displayId, Validators.required],
      name: [this.newSite.name, Validators.required],
      logoUrl: [this.newSite.logoUrl],
      displayLogoName: '',
    });
  }

  onSubmit(): void {
    Object.assign(this.newSite, this.fg.value);
    this.newSite.isEnabled = true;
    if (checkInvalid([this.fg], this.formElementRef, true)) {
      return;
    }
    let localFile = false;
    let logoPath = this.logoHospital;
    if (this.fg.get('displayLogoName').value === '') {
      localFile = true;
      logoPath = this.newSite.logoUrl;
    }
    this.loadingScreenService.startLoading();
    this.authSer.uploadLogoToFireStorage(logoPath, localFile, '').then((url) => {
      this.newSite.logoUrl = url;
      this._ss.createSite(this.newSite).then(
        (res: any) => {
          this.loadingScreenService.stopLoading();
          this.dialogRef.close(true);
        }
      ).catch(() => {
        this.fg.get('displayId').setErrors({ 'duplicate': true });
        this.fg.get('displayId').markAsTouched();
        this.fg.get('displayId').markAsDirty();
      }).finally(() => {
        this.loadingScreenService.stopLoading();
      });
    }).catch(function (uploadError) {
      // Handle Errors here.
      console.log('error.code : ' + uploadError.code + ', error.msg : ' + uploadError.message);
      this.loadingScreenService.stopLoading();
    });
  }
}
